<template>
  <Nav />
  <main>
    <router-view />
  </main>
</template>

<script>
  import Nav from '@/components/frontend/Nav.vue'

  export default {
    name: 'FrontendLayout',
    components: {
      Nav
    }
  }
</script>

<style scoped>
  
</style>